import React, { Component, Fragment } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import CustomSelect from "./CustomSelect";
import { StatesList } from "../../Code/Data";

export default class ShippingInfoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shippingInfo: null,
    };

    this.handleChange = this.handleChange.bind(this);
    this.saveInfo = this.saveInfo.bind(this);
  }

  getStateFromProps() {
    let { shippingInfo } = this.props;
    this.setState({ shippingInfo: JSON.parse(JSON.stringify(shippingInfo)) });
  }

  componentDidMount() {
    this.getStateFromProps();
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.getStateFromProps();
    }
  }

  handleChange(key, value) {
    let { shippingInfo } = this.state;
    shippingInfo = JSON.parse(JSON.stringify(shippingInfo));
    shippingInfo[key] = value;
    this.setState({ shippingInfo });
  }

  saveInfo() {
    let { shippingInfo } = this.state;
    this.props.saveInfo(shippingInfo);
  }

  render() {
    const { isOpen, onClose } = this.props;
    const { shippingInfo } = this.state;

    let modalContents = null;
    if (shippingInfo) {
      const {
        ShippingFirstName,
        ShippingLastName,
        ShippingAttn,
        ShippingAddress1,
        ShippingAddress2,
        ShippingCity,
        ShippingState,
        ShippingZip,
        Email,
        ShippingPhone,
      } = shippingInfo;

      modalContents = (
        <Fragment>
          <FormGroup className="has-float-label">
            <Input
              type="text"
              id="ShippingFirstName"
              placeholder="First Name"
              autoComplete="given-name"
              value={ShippingFirstName || ""}
              onChange={e =>
                this.handleChange("ShippingFirstName", e.target.value)
              }
            />
            <Label for="ShippingFirstName">First Name</Label>
          </FormGroup>
          <FormGroup className="has-float-label">
            <Input
              type="text"
              id="ShippingLastName"
              placeholder="Last Name"
              autoComplete="family-name"
              value={ShippingLastName || ""}
              onChange={e =>
                this.handleChange("ShippingLastName", e.target.value)
              }
            />
            <Label for="ShippingLastName">Last Name</Label>
          </FormGroup>
          <FormGroup className="has-float-label">
            <Input
              type="text"
              id="ShippingAttn"
              placeholder="Attention"
              value={ShippingAttn || ""}
              onChange={e => this.handleChange("ShippingAttn", e.target.value)}
            />
            <Label for="ShippingAttn">Attn</Label>
          </FormGroup>
          <FormGroup className="has-float-label">
            <Input
              type="text"
              id="ShippingAddress1"
              placeholder="Address 1"
              autoComplete="shipping address-line1"
              value={ShippingAddress1 || ""}
              onChange={e =>
                this.handleChange("ShippingAddress1", e.target.value)
              }
            />
            <Label for="ShippingAddress1">Address Line 1</Label>
          </FormGroup>
          <FormGroup className="has-float-label">
            <Input
              type="text"
              id="ShippingAddress2"
              placeholder="Address 2"
              autoComplete="shipping address-line2"
              value={ShippingAddress2 || ""}
              onChange={e =>
                this.handleChange("ShippingAddress2", e.target.value)
              }
            />
            <Label for="ShippingAddress2">Address Line 2</Label>
          </FormGroup>
          <FormGroup className="has-float-label">
            <Input
              type="text"
              id="ShippingCity"
              placeholder="City"
              autoComplete="shipping locality"
              value={ShippingCity || ""}
              onChange={e => this.handleChange("ShippingCity", e.target.value)}
            />
            <Label for="ShippingCity">City</Label>
          </FormGroup>
          <FormGroup className="has-float-label">
            <CustomSelect
              name="ShippingState"
              placeholder="State"
              autoComplete="shipping region"
              options={StatesList}
              selectedValue={ShippingState}
              onChange={selectedState =>
                this.handleChange("ShippingState", selectedState)
              }
            />
          </FormGroup>
          <FormGroup className="has-float-label">
            <Input
              type="text"
              id="ShippingZip"
              placeholder="Zip"
              name="zip"
              autoComplete="shipping postal-code"
              value={ShippingZip || ""}
              onChange={e => this.handleChange("ShippingZip", e.target.value)}
            />
            <Label for="ShippingZip">Zip Code</Label>
          </FormGroup>
          <FormGroup className="has-float-label">
            <Input
              type="text"
              id="Email"
              placeholder="Email"
              autoComplete="email"
              value={Email || ""}
              onChange={e => this.handleChange("Email", e.target.value)}
            />
            <Label for="Email">Email</Label>
          </FormGroup>
          <FormGroup className="has-float-label">
            <Input
              type="text"
              id="ShippingPhone"
              placeholder="Phone"
              autoComplete="tel"
              value={ShippingPhone || ""}
              onChange={e => this.handleChange("ShippingPhone", e.target.value)}
            />
            <Label for="ShippingPhone">Phone #</Label>
          </FormGroup>
        </Fragment>
      );
    }

    return (
      <Modal isOpen={isOpen} toggle={onClose} backdrop={false}>
        <ModalHeader>Enter Shipping Info</ModalHeader>
        <ModalBody>{modalContents}</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.saveInfo}>
            Save
          </Button>
          <Button color="secondary" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
